import React, {memo, useContext} from 'react';

import {PanelBankContext} from '../../state/panelbank/context';
import {CreateReportModalContent} from './CreateReportModalContent';
import {type CreateReportModalProps} from './types';

const CreateReportModalComp = (props: CreateReportModalProps) => {
  const {
    exportingUnknownID: exporting,
    exportingPanelRefID,
    exportingSectionRefID,
  } = useContext(PanelBankContext);
  const isExporting =
    exporting || exportingPanelRefID != null || exportingSectionRefID != null;

  // Important: only render the modal if we need it! It fetches the entire
  // panelBank config, we don't want this to happen normally
  if (!isExporting) {
    return null;
  }

  return <CreateReportModalContent {...props} />;
};

export const CreateReportModal = memo(CreateReportModalComp);
